export default [
    { // 집계분류 관리
        path: 'aggr-cate',
        redirect: { name: 'AggrCateList' },
        children: [
            {
                path: 'list',
                name: 'AggrCateList',
                meta: { menu: 'aggr-cate', keepAlive: true },
                component: () => import('@/pages/resvMng/common/aggrCate/AggrCateListView.vue')
            },
            {
                path: 'add',
                name: 'AggrCateInsert',
                meta: { menu: 'aggr-cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/aggrCate/AggrCateInsertView.vue')
            },
            {
                path: 'modify/:totClsfId',
                name: 'AggrCateUpdate',
                meta: { menu: 'aggr-cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/aggrCate/AggrCateUpdateView.vue'),
                props: true
            }
        ]
    },
    { // 카테고리 관리
        path: 'cate',
        redirect: { name: 'CateList' },
        children: [
            {
                path: 'list',
                name: 'CateList',
                meta: { menu: 'cate', keepAlive: true },
                component: () => import('@/pages/resvMng/common/cate/CateListView.vue')
            },
            {
                path: 'add',
                name: 'CateInsert',
                meta: { menu: 'cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/cate/CateInsertView.vue')
            },
            {
                path: 'modify/:gdsClsfId',
                name: 'CateUpdate',
                meta: { menu: 'cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/cate/CateUpdateView.vue'),
                props: true
            },
            {
                path: 'lv3-add',
                name: 'CateLv3Insert',
                meta: { menu: 'cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/cate/CateInsertView.vue')
            },
            {
                path: 'lv3-update/:gdsClsfId',
                name: 'CateLv3Update',
                meta: { menu: 'cate', keepAlive: false },
                component: () => import('@/pages/resvMng/common/cate/CateUpdateView.vue'),
                props: true
            },
            {
                path: 'cate-shop-popup',
                name: 'CateShopPopup',
                meta: { menu: 'cate', keepAlive: false, layout: 'blank' },
                component: () => import('@/pages/resvMng/common/cate/components/CateShopPopup.vue'),
                props: (route) => ({ gdsClsfDcd: route.query.gdsClsfDcd })
            }
        ]
    },
    { // (구) 예약내역 조회
        path: 'old-rsrvt',
        redirect: { name: 'OldRsrvtList' },
        children: [
            {
                path: 'list',
                name: 'OldRsrvtList',
                meta: { menu: 'oldRsrvt', keepAlive: true },
                component: () => import('@/pages/resvMng/common/oldRsrvt/OldRsrvtListView.vue')
            },
            {
                path: 'modify/:ordrNo/:mbrUnqId',
                name: 'OldRsrvtUpdate',
                meta: { menu: 'oldRsrvt', keepAlive: false },
                component: () => import('@/pages/resvMng/common/oldRsrvt/OldRsrvtUpdateView.vue'),
                props: true
            }
        ]
    },
    { // 휴일현황
        path: 'holi-mng',
        redirect: {  name: 'HoliList' },
        children: [
            {
                path: 'list',
                name: 'HoliList',
                meta: { menu: 'holi' },
                component: () => import('@/pages/resvMng/common/holi/HoliContainer.vue')
            },
            {
                path: 'add',
                name: 'HolidayInsert',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/holiday/HolidayInsertView.vue')
            },
            {
                path: 'modify/:hldyId',
                name: 'HolidayUpdate',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/holiday/HolidayUpdateView.vue'),
                props: true
            },
            {
                path: 'fixed-add',
                name: 'FixedHolidayInsert',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/fixedHoliday/FixedHolidayInsertView.vue')
            },
            {
                path: 'fixed-modify/:fixHldyId',
                name: 'FixedHolidayUpdate',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/fixedHoliday/FixedHolidayUpdateView.vue'),
                props: true
            },
            {
                path: 'regular-add',
                name: 'RegularHolidayInsert',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/regularHoliday/RegularHolidayInsertView.vue')
            },
            {
                path: 'regular-modify/:hldyId',
                name: 'RegularHolidayUpdate',
                meta: { menu: 'holi', keepAlive: false },
                component: () => import('@/pages/resvMng/common/holi/tabs/regularHoliday/RegularHolidayUpdateView.vue'),
                props: true
            },
        ]
    },
    {
        path: 'mmbr-list-popup',
        name: 'MmbrListPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/resvMng/common/popup/MmbrListPopup.vue'),
        props : (route) => ({ authrtCd: route.query.authrtCd || '' })
    },
    {
        path: 'sms-send-popup',
        name: 'SmsSendPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/resvMng/common/popup/SmsSendPopup.vue'),
    },
    {
        path: 'sms-excel-upload-popup',
        name: 'SmsExcelUploadPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/resvMng/common/popup/SmsExcelUploadPopup.vue'),
    },
    {
        path: 'mmbr-reg-popup',
        name: 'MmbrRegPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/resvMng/common/popup/MmbrRegPopup.vue'),
    },
    // 결제/환불 공통 팝업
    {
        path: 'payment-popup',
        name: 'PaymentPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/resvMng/common/popup/PaymentPopup.vue'),
        props: (route) => ({
            rsvtType: route.query.rsvtType || 'spfc',
            rsvtNo: route.query.rsvtNo
        })
    },
    {
        path: 'payment-history-popup',
        name: 'PaymentHistoryPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/resvMng/common/popup/PaymentHistoryPopup.vue'),
        props: (route) => ({
            rsvtType: route.query.rsvtType || 'spfc',
            rsvtNo: route.query.rsvtNo
        })
    },
    {
        path: 'manual-receipt-popup',
        name: 'ManualReceiptPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/resvMng/common/popup/ManualReceiptPopup.vue'),
        props: (route) => ({
            rsvtType: route.query.rsvtType || 'spfc',
            rsvtNo: route.query.rsvtNo
        })
    },
    {
        path: 'slip-search-popup',
        name: 'SlipSearchPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/resvMng/common/popup/SlipSearchPopup.vue'),
        props: (route) => ({
            rsvtType: route.query.rsvtType || 'spfc',
            slipCrtNo: route.query.slipCrtNo
        })
    },
]
